import { type ReactNode } from 'react';

import './_glassCardGrid.scss';
import clsx from 'clsx';

/** Props for the GlassCardGrid container. */
export interface GlassCardGridProps {
  className?: string;
  children?: ReactNode;
}

export function GlassCardGrid({ className, children }: GlassCardGridProps) {
  return (
    <div className={clsx('glass-card-grid', className)}>
      <div className="glass-card-grid__inner">{children}</div>
    </div>
  );
}
